export default __webpack_public_path__ + "static/media/food-presentation-3.fe10d38a.jpg";